module.exports = __webpack_public_path__ + "769065a57e51990bfc6efda98a281ee6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/guitar-acoustic.png
// module id = 1898
// module chunks = 0